import { render, staticRenderFns } from "./TaskCalendar.vue?vue&type=template&id=3fa8a9fa&scoped=true&"
import script from "./TaskCalendar.vue?vue&type=script&lang=ts&"
export * from "./TaskCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8a9fa",
  null
  
)

export default component.exports